/**
 * Created by richard on 7/14/14.
 */
var gradeSetupModel = angular.module('gradeSetupModel', ['schoolModel']);
gradeSetupModel.factory('GradeSetupModelFactory', function(ApplicationService, RestService, authServiceFactory, SchoolModelFactory, AbstractModelService){
    var GradeSetupModel = function(){
        this.endpoint = "/Tuition";
        this.primaryKey = "recordID";
    }
    GradeSetupModel.prototype = new SchoolModelFactory();
    GradeSetupModel.prototype.parent = SchoolModelFactory.prototype;

    GradeSetupModel.prototype.new = function()
    {
        var schoolID = this.getSchoolID();
        var grade = {schoolID: schoolID, InUse: '0', del: '0', Division: '', DivisionCode: '', divisionDesc: '',
            questionOrder: this.data.length, tuition: ''};
        return grade;
    }
    return GradeSetupModel;
});


gradeSetupModel.service('GradeSetupModelService', function(GradeSetupModelFactory){
    var gradeSetupModel = new GradeSetupModelFactory();
    return gradeSetupModel;
});


